import { useCallback, useEffect, useState, useContext } from "react";

import { IsFormSaved } from '../context/FromStatusContext';

import { SecureGet, SecurePost, SecurePut } from "../services/axiosCall";

const usePlanning = ({
  url,
  formId,
  userDetails,
  selectedYear,
  messageApi,
  convertToTableData,
  convertToRequestData,
}) => {
  const { setIsFormSaved } = useContext(IsFormSaved);

  // this value will decide is it all ready create or not
  const [id, setId] = useState(null);
  const handleId = (id) => setId(id);

  const [fetchLoading, setFetchLoading] = useState(false);
  const handleFetchLoading = (loading) => setFetchLoading(loading);

  const [updateLoading, setUpdateLoading] = useState(false);
  const handleUpdateLoading = (loading) => setUpdateLoading(loading);

  const [planing, setPlaning] = useState([]);
  const handlePlaning = (plan) => setPlaning(plan);

  const [_planing, _setPlaning] = useState([]);
  const _handlePlaning = (plan) => _setPlaning(plan);

  const [updated, setUpdated] = useState(false);

  const [initialNoPlanning, setInitialNoPlanning] = useState(false);
  const [noPlanning, setNoPlanning] = useState(false);
  const handleNoPlanning = (pl) => setNoPlanning(pl);

  const [maxEstimatedPoint, setMaxEstimatedPoint] = useState(0)
  const handleMaxEstimatedPoint = (el) => setMaxEstimatedPoint(el)

  const fetchPlaning = useCallback((year, formId) => {
    handlePlaning([]);
    _handlePlaning([]);
    handleFetchLoading(true);

    SecureGet({
      url: `${url}`,
      params: {
        year,
        apa_form: formId,
      },
    })
      .then((response) => {

        handlePlaning(
          response.data.results &&
            response.data.results.length &&
            response.data.results[0].planning
            ? convertToTableData
              ? convertToTableData(response.data.results[0].planning)
              : response.data.results[0].planning
            : []
        );
        handleFetchLoading(false);

        handleNoPlanning(response?.data?.results?.length > 0 ? response?.data?.results?.[0]?.no_planning : false)
        setInitialNoPlanning(response?.data?.results?.length > 0 ? response?.data?.results?.[0]?.no_planning : false)

        handleMaxEstimatedPoint(response?.data?.results?.length > 0 ? response?.data?.results?.[0]?.max_estimated_point : 0)

        handleId(
          response.data.results &&
            response.data.results.length &&
            response.data.results[0].id
            ? response.data.results[0].id
            : null
        );

        _handlePlaning(
          response.data.results &&
            response.data.results.length &&
            response.data.results[0].planning
            ? convertToTableData
              ? convertToTableData(response.data.results[0].planning)
              : response.data.results[0].planning
            : []
        );
      })
      .catch(() => {
        handleFetchLoading(false);
      });
  }, []);

  const updatePlaning = () => {
    handleUpdateLoading(true);

    const newPlan = {
      apa_form: formId,
      year: selectedYear,
      no_planning: noPlanning,
      planning: convertToRequestData ? convertToRequestData(planing) : planing,
      user: userDetails,

    };
    if (id) {
      SecurePut({
        url: `${url}/${id}`,
        data: { ...newPlan },
      })
        .then(() => {
          fetchPlaning(selectedYear, formId);
          messageApi.success("Successfully updated");
          handleUpdateLoading(false);

        })
        .catch((error) => {
          handleUpdateLoading(false);

          const { response } = error;
          const { data } = response || {};
          const { error: errorMsg } = data || {};

          if (errorMsg) messageApi.error(errorMsg, 5);
          else messageApi.error("Something went wrong", 5)
        });
    } else {
      SecurePost({
        url: `${url}`,
        data: { ...newPlan },
      })
        .then(() => {
          fetchPlaning(selectedYear, formId);

          handleUpdateLoading(false);
          messageApi.success("Successfully updated");
        })
        .catch((error) => {
          handleUpdateLoading(false);
          const { response } = error;
          const { data } = response || {};
          const { error: errorMsg } = data || {};

          if (errorMsg)
            // messageApi.error(errorMsg,5);
            messageApi.open({
              type: 'error',
              content: errorMsg,
              duration: 5,
              style: {
                fontWeight: 'bold',
                fontSize: '15px',
              },
              className: 'custom-error-message',
            });
          else
            messageApi.open({
              type: 'error',
              content: 'Something went wrong',
              duration: 5,
              style: {
                fontWeight: 'bold',
                fontSize: '15px',
              },
              className: 'custom-error-message',
            });
        });
    }
  };

  useEffect(() => {
    if (formId && selectedYear) {
      fetchPlaning(selectedYear, formId)
    };
  }, [fetchPlaning, formId, selectedYear, url, userDetails]);

  useEffect(() => {
    if (JSON.stringify(planing) === JSON.stringify(_planing) && noPlanning === initialNoPlanning) {
      setIsFormSaved(true);
      setUpdated(false)
    } else {
      setIsFormSaved(false);
      setUpdated(true)
    };
  }, [_planing, planing, noPlanning]);

  useEffect(() => {
    setIsFormSaved(true)
  }, []);

  return {
    planing,
    updated,
    fetchLoading,
    updateLoading,
    updatePlaning,
    handlePlaning,
    noPlanning,
    handleNoPlanning,
    maxEstimatedPoint
  };
};

export default usePlanning;
